import { push } from 'react-router-redux';
import { routingConstants } from '../utils/types';
import routeConstants from '../utils/routeConstants';
import {
  setPendingBookingSessionEventId,
  setPendingBookingCourtEventId
} from './pendingBookingActions';
import { endRouteActionsTypes, idsNames } from '../utils/constants';
import { setScrollToId } from './scrollToActions';
import ConditionHelperObj from '../utils/helpers/ConditionHelper';

export function setSignEndRoute(signEndRoute) {
  return {
    type: routingConstants.SET_SIGN_END_ROUTE,
    payload: {
      signEndRoute
    }
  };
}

export function setSignEndRouteAction(type, param) {
  return {
    type: routingConstants.SET_SIGN_END_ROUTE_ACTION,
    payload: {
      type,
      param
    }
  };
}

export function setSignCancelRoute(signCancelRoute) {
  return {
    type: routingConstants.SET_SIGN_CANCEL_ROUTE,
    payload: {
      signCancelRoute
    }
  };
}

export function setPaymentEndRoute(paymentEndRoute) {
  return {
    type: routingConstants.SET_PAYMENT_END_ROUTE,
    payload: {
      paymentEndRoute
    }
  };
}

export function setPaymentEndRouteAction(type, param) {
  return {
    type: routingConstants.SET_PAYMENT_END_ROUTE_ACTION,
    payload: {
      type,
      param
    }
  };
}

export function executeEndRouteAction(type, param) {
  return dispatch => {
    switch (type) {
    case endRouteActionsTypes.PENDING_SESSION_BOOKING:
      dispatch(setPendingBookingSessionEventId(param));
      dispatch(setScrollToId(`${idsNames.SESSION_ID_PREFIX}${param}`));
      break;
    case endRouteActionsTypes.PENDING_COURT_BOOKING:
      dispatch(setPendingBookingCourtEventId(param));
      dispatch(setScrollToId(`${idsNames.COURT_ID_PREFIX}${param}`));
      break;
    default:
      break;
    }
  };
}

export function routeToSignEndRoute() {
  return (dispatch, getState) => {
    const { signEndRoute } = getState().routing;
    const {
      signEndRouteActionType,
      signEndRouteActionParam
    } = getState().routing;

    dispatch(
      executeEndRouteAction(signEndRouteActionType, signEndRouteActionParam)
    );

    dispatch(setSignEndRouteAction(null, null));
    dispatch(push(signEndRoute || routeConstants.SESSIONS_ROUTE));
  };
}

export function routeToPaymentEndRoute() {
  return (dispatch, getState) => {
    const { paymentEndRoute } = getState().routing;
    const {
      paymentEndRouteActionType,
      paymentEndRouteActionParam
    } = getState().routing;

    dispatch(
      executeEndRouteAction(
        paymentEndRouteActionType,
        paymentEndRouteActionParam
      )
    );

    dispatch(setPaymentEndRouteAction(null, null));
    dispatch(push(paymentEndRoute || routeConstants.HOME_ROUTE));
  };
}

export function routeToSignCancelRoute() {
  return (dispatch, getState) => {
    const { signCancelRoute } = getState().routing;
    dispatch(setSignEndRouteAction(null, null));
    dispatch(push(signCancelRoute || routeConstants.SESSIONS_ROUTE));
  };
}

export function routeToPaymentFlow(eventId, backRoute, endRouteActionType) {
  return dispatch => {
    dispatch(setPaymentEndRouteAction(endRouteActionType, eventId));
    dispatch(setPaymentEndRoute(backRoute));
    dispatch(push(routeConstants.DEUCE_PREMIUM_PAGE));
  };
}

export function routeToSignFlow(eventId, backRoute, endRouteActionType) {
  return dispatch => {
    dispatch(setSignEndRouteAction(endRouteActionType, eventId));
    dispatch(setSignEndRoute(backRoute));
    dispatch(setSignCancelRoute(backRoute));
    dispatch(push(routeConstants.SIGNUP_ROUTE));
  };
}

export function processActionIfUserLogged(
  action,
  event,
  backRoute,
  endRouteActionType
) {
  return dispatch => {
    const userLogged = ConditionHelperObj.isUserLogged();
    if (userLogged) {
      action();
    } else {
      dispatch(routeToSignFlow(event.id, backRoute, endRouteActionType));
    }
  };
}

export function processActionIfUserSubscribe(
  action,
  event,
  backRoute,
  endRouteActionType
) {
  return dispatch => {
    const userLogged = ConditionHelperObj.isUserLogged();
    const userIsSubscriber = ConditionHelperObj.isUserSubscriber();
    if (userLogged && userIsSubscriber) {
      action();
    } else if (userLogged) {
      dispatch(routeToPaymentFlow(event.id, backRoute, endRouteActionType));
    } else {
      dispatch(routeToSignFlow(event.id, backRoute, endRouteActionType));
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/routingActions.js